import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  requestUserSignUpAsync,
  requestForSignUpEmailVerificationCodeAsync,
  requestForSignUpPhoneVerificationCodeAsync,
  requestForSignUpValidationAsync,
} from "apis/SignUpApi";
import { handlePostSignInOperations } from "store/slices/AuthenticationSlice";
import AuthResponse from "interfaces/response/AuthResponse";
import SignUpEmailVerificationCodeRequest from "interfaces/request/SignUpEmailVerificationCodeRequest";
import SignUpPhoneVerificationCodeRequest from "interfaces/request/SignUpPhoneVerificationCodeRequest";
import SignUpRequest from "interfaces/request/SignUpRequest";
import SignUpValidationRequest from "interfaces/request/SignUpValidationRequest";
import BaseState from "interfaces/state/BaseState";

interface SignUpState extends BaseState {}

const initialState: SignUpState = {
  loading: false,
};

export const signUpValidationRequestAsync = createAsyncThunk(
  "signup/signUpValidationRequestAsync",
  async (postData: SignUpValidationRequest) => {
    return await requestForSignUpValidationAsync(postData);
  }
);

export const requestForUserSignUpAsync = createAsyncThunk(
  "signup/signUp",
  async (postData: SignUpRequest) => {
    return await requestUserSignUpAsync(postData);
  }
);

export const signUpEmailVerificationCodeRequtestAsync = createAsyncThunk(
  "signup/signUpEmailVerificationCodeRequtestAsync",
  async (postData: SignUpEmailVerificationCodeRequest) => {
    return await requestForSignUpEmailVerificationCodeAsync(postData);
  }
);

export const signUpPhoneVerificationCodeRequtestAsync = createAsyncThunk(
  "signup/signUpPhoneVerificationCodeRequtestAsync",
  async (postData: SignUpPhoneVerificationCodeRequest) => {
    return await requestForSignUpPhoneVerificationCodeAsync(postData);
  }
);

export const setPostSignUpAuthenticationResponseAsync = createAsyncThunk(
  "signup/setPostSignUpAuthenticationResponse",
  async (response: AuthResponse, { dispatch }) => {
    dispatch(handlePostSignInOperations(response));
    return response;
  }
);

export const signUpSlice = createSlice({
  name: "signup",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(requestForUserSignUpAsync.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(requestForUserSignUpAsync.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(requestForUserSignUpAsync.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(signUpValidationRequestAsync.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(signUpValidationRequestAsync.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(signUpValidationRequestAsync.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(
      signUpEmailVerificationCodeRequtestAsync.pending,
      (state, action) => {
        state.loading = true;
      }
    );
    builder.addCase(
      signUpEmailVerificationCodeRequtestAsync.rejected,
      (state, action) => {
        state.loading = false;
      }
    );
    builder.addCase(
      signUpEmailVerificationCodeRequtestAsync.fulfilled,
      (state, action) => {
        state.loading = false;
      }
    );
    builder.addCase(
      signUpPhoneVerificationCodeRequtestAsync.pending,
      (state, action) => {
        state.loading = true;
      }
    );
    builder.addCase(
      signUpPhoneVerificationCodeRequtestAsync.rejected,
      (state, action) => {
        state.loading = false;
      }
    );
    builder.addCase(
      signUpPhoneVerificationCodeRequtestAsync.fulfilled,
      (state, action) => {
        state.loading = false;
      }
    );
    builder.addCase(
      setPostSignUpAuthenticationResponseAsync.fulfilled,
      (state, action) => {
        return { ...action.payload, loading: false };
      }
    );
  },
});

export default signUpSlice.reducer;
